<template>
  <section class="actile-card">
    <div class="left">
      <router-link target="_blank" :to="`/article/detail/${item.id}`">
        <h4>{{item.title}}</h4>
        <p v-html="delStyleTag(item.content)"></p>
      </router-link>
      <div class="info">
        <div class="createTime">
          <span class="time">{{item.articleReleaseTime | dateToNow(language)}}</span>
          <!-- <img src="/static/v2/article/view_icon.png" />
          <span class="view">{{item.viewCount || 0}}</span> -->
        </div>
      </div>
    </div>
    <div class="right" v-if="image">
      <img :src="image| imageUrl('',356,200,'','gif')" alt />
    </div>
  </section>
</template>

<script>
export default {
  props: ["item", "topicId"],
  data() {
    return {};
  },
  computed: {
    image() {
      let src = "";
      const imageList = this.item.content.match(/<img[^>]*>/);
      if (imageList && imageList.length) {
        imageList[0].replace(/src="([^"]*)"/, (a, b) => (src = b));
      }
      return src;
    },
    language() {
      return this.$language();
    }
  },
  methods: {
    delStyleTag(str) {
      return str
        .replace(/<style((?!<\/style>).)*<\/style>/g, "")
        .replace(/&lt;/g, "<")
        .replace(/↵/g, "")
        .replace(/<[^>]+>/g, "");
    },
    myCenter() {
      this.$router.push(`/peopleCenter/${this.item.userId}`);
    }
  }
};
</script>

<style lang="stylus" scoped>
.actile-card {
  display: flex;
  flex-direction: row;

  .left {
    flex: 1;
    max-width: 800px;

    a {
      h4 {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        line-height: 22px;
        color: #0A0A0A;
        padding-bottom: 13px;
      }

      &>p {
        font-size: 14px;
        color: #999;
        line-height: 20px;
        height: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-word;
      }
    }

    div.info {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-top: 18px;

      .createTime {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 14px;

        span {
          color: #B8B8B8;
          padding-right: 20px;
        }

        img {
          width: 18px;
          height: 12px;
          margin-right: 4px;
        }
      }
    }
  }

  .right {
    width: 178px;
    margin-left: 12px;

    img {
      width: 178px;
      height: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/v2/peopleCenter/ArticleCard.vue